var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border rounded p-5 text-center"},[_c('span',[_vm._v(_vm._s(_vm.$t('no_result')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }